const lazyImgs = function (next) {

	const lazyImgEls = next.querySelectorAll('img.lazy')

	if (lazyImgEls.length < 1)
		return // didn't find any images, exiting...

	let options = {
		rootMargin: '0px 0px -16px 0px',
		threshold: 0
	}

	const lazyImgObserver = new IntersectionObserver(els => {
		els.forEach(el => {
			const theImage = el.target

			if (el.isIntersecting) {
				theImage.src = theImage.dataset.src
				lazyImgObserver.unobserve(theImage);
				theImage.onload = function() {
					theImage.style.opacity = "0";
					setTimeout(() => theImage.classList.add('loaded'), 50)
				}
				theImage.onerror = function() {
					theImage.style.background = "none";
				}
				return;
			}
		});
	}, options);

	lazyImgEls.forEach(el => {
		lazyImgObserver.observe(el);
	})

}

export default lazyImgs